import { defineComponent as _defineComponent } from 'vue'
import AddToCartSuccess from 'JS/components/side-menus/add-to-cart/AddToCartSuccess.vue';
import CannotAddToCart from 'JS/components/side-menus/add-to-cart/CannotAddToCart.vue';
import DeliveryConfirmation from 'JS/components/side-menus/add-to-cart/DeliveryConfirmation.vue';
import FulfillmentError from 'JS/components/side-menus/add-to-cart/FulfillmentError.vue';
import MaxLineItems from 'JS/components/side-menus/add-to-cart/MaxLineItems.vue';
import ProductAgreement from 'JS/components/side-menus/add-to-cart/ProductAgreement.vue';
import SideMenu from 'JS/components/SideMenu.vue';
import Spinner from 'JS/components/Spinner.vue';
import { AddToCartResult, IPDPAddToCartResponse } from 'JS/services/ProductService';
import { computed, ref, watch } from 'vue';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { getFocusableElements } from 'JS/utilities/dom';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductGroupSelectorValue } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCartSidebar',
  props: {
    show: { type: Boolean },
    addToCartInfo: null,
    localStore: null,
    loading: { type: Boolean, default: false },
    pdpSelectedAttributes: { default: () => ({}) },
    carouselTrackingUrl: null
  },
  emits: ["close", "confirmFulfillment", "confirmError", "confirmAgreement", "maxhit"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void,
	(e: 'confirmFulfillment'): void,
	(e: 'confirmError', fulfillmentType: FulfillmentType): void,
	(e: 'confirmAgreement'): void;
	(e: 'maxhit'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { show: boolean, addToCartInfo: IPDPAddToCartResponse, localStore: ILocalStoreJson, loading: boolean, pdpSelectedAttributes: Record<string, IProductGroupSelectorValue>, carouselTrackingUrl?: string }




const childLoading = ref<boolean>(false);
const showLoading = computed<boolean>(() => props.loading || childLoading.value);
const baseElement = ref<HTMLElement | null>(null);

const menuTitle = computed<string>(() => {
	if (props.addToCartInfo?.result == AddToCartResult.RequireConfirmation) {
		return "Confirm Fulfillment Method";
	} else if (props.addToCartInfo?.result == AddToCartResult.MaxLines) {
		return "Cart Full Error";
	} else if (props.addToCartInfo?.result == AddToCartResult.PickupDeliveryError) {
		return "Fulfillment Error";
	} else if (props.addToCartInfo?.result == AddToCartResult.RequireAgreement) {
		return "Please Read and Agree to Continue";
	} else if (props.addToCartInfo?.result == AddToCartResult.Success) {
		if (props.addToCartInfo?.addedProducts?.length > 1) {
			return "Added " + props.addToCartInfo.addedProducts.length + " Items to Cart";
		}
		return "Added to Cart";
	} else {
		return "Cannot Add to Cart";
	}
});

watch(() => props.show, (newValue) => {
	if (newValue) {
		//Reset to initial values on open
		childLoading.value = false;
	 }
});

watch(() => props.addToCartInfo?.result, (newValue, oldValue) => {
	if (newValue !== oldValue) {
		setFocusToTop();
	 }
});

function toggleLoading(loading: boolean) {
	childLoading.value = loading;
}

function maxItemsHit() {
	emit('maxhit');
}

function goToCart() {
	emit('close');
	if (typeof window !== 'undefined') {
		window.location.href = "/cart/";
	}
}

function reloadPage() {
	emit('close');
	if (typeof window !== 'undefined') {
		window.location.reload();
	}
}

function confirmError(fulfillmentType: FulfillmentType) {
	return emit('confirmError', fulfillmentType);
}

function confirmAgreement() {
	return emit('confirmAgreement');
}

function setFocusToTop() {
	const firstFocusable = getFocusableElements(baseElement.value as HTMLElement)[0];
	firstFocusable?.focus();
}

return { __sfc: true,props, emit, childLoading, showLoading, baseElement, menuTitle, toggleLoading, maxItemsHit, goToCart, reloadPage, confirmError, confirmAgreement, setFocusToTop, AddToCartSuccess, CannotAddToCart, DeliveryConfirmation, FulfillmentError, MaxLineItems, ProductAgreement, SideMenu, Spinner, AddToCartResult }
}

})